import React from 'react';

const Gold = props => {
  return (
    <svg viewBox="-0.5 0.5 20 20" {...props}>
      <path
        fill="#DAC251"
        stroke="#DAB710"
        strokeWidth="1"
        d="M1,1 L17,1 C17.5522847,1 18,1.44771525 18,2 L18,18.2813842 C18,18.833669
        17.5522847,19.2813842 17,19.2813842 C16.8267541,19.2813842 16.6564801,19.2363755
        16.5058629,19.1507682 L9.15451242,14.9724365 C8.83720585,14.7920871 8.44684565,
        14.798933 8.13605799,14.9902976 L1.52431736,19.0614157 C1.05403423,19.3509882
        0.43804955,19.2044933 0.148477067,18.7342101 C0.0514010065,18.5765528
        -1.3095936e-15,18.3950403 0,18.2098928 L0,2 C-6.76353751e-17,1.44771525 0.44771525,
        1 1,1 Z"
      ></path>
    </svg>
  );
};
export default Gold;
